__webpack_require__.p = "/simple-reversi-game/";